module.exports = __webpack_public_path__ + "img/img4.df86032d.png";